import { render, staticRenderFns } from "./ArchiveList.vue?vue&type=template&id=317913c0&"
import script from "./ArchiveList.vue?vue&type=script&lang=js&"
export * from "./ArchiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports